import React from 'react';
import { Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { step452 } from 'assets/learning';

const EngageLearningScreen36 = () => {
  const { t } = useTranslation();

  return (
    <>
      <h4 id="step-4-5-2" className='text-engage'>{t('learning.engage.181')}</h4>
      <p>{t('learning.engage.182')}</p>
      <p><b>{t('learning.engage.183')}</b></p>
      <br/><br/>
      <div className='text-center'>
        <Image src={step452} width={'50%'} />
      </div>
    </>
  )

}

export default EngageLearningScreen36;